import { useState } from 'react';

import { appBorders } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, IconButton, InputAdornment, SxProps, Theme } from '@mui/material';
import TextareaAutosize, { TextareaAutosizeProps } from 'react-textarea-autosize';

const { inputBox } = appStrings.modules;

type InputBoxProps = Readonly<{
  sendMessage: (params: { message: string; newSessionId?: number }) => void;
  isActive?: boolean;
  sessionId?: number;
}>;

export const InputBox = ({ sendMessage, isActive, sessionId }: InputBoxProps) => {
  const [input, setInput] = useState('');

  const handleSendMessage = () => {
    if (!input.trim() || !sessionId) return;

    sendMessage({
      message: input,
      newSessionId: sessionId,
    });
    setInput('');
  };

  return (
    <Box sx={containerStyle}>
      <Box sx={boxStyle}>
        <TextareaAutosize
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter' && isActive) {
              e.preventDefault();
              handleSendMessage();
            }
          }}
          placeholder={isActive ? inputBox.askLubav : ''}
          style={{
            ...messageInputTextarea,
            color: isActive ? 'inherit' : '#a0a0a0',
          }}
          disabled={!isActive}
          minRows={1}
          maxRows={Math.floor((window.innerHeight * 0.2) / 24)}
        />
        <InputAdornment position="end" sx={inputAdornmentStyle}>
          <IconButton onClick={handleSendMessage} disabled={!isActive}>
            <img
              src="/send-message-icon.svg"
              alt="Send Message"
              style={{
                ...sendMessageIcon,
                opacity: isActive ? '100%' : '50%',
                filter: isActive ? 'none' : 'grayscale(100%)',
              }}
            />
          </IconButton>
        </InputAdornment>
      </Box>
    </Box>
  );
};

const containerStyle: SxProps<Theme> = {
  width: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column-reverse',
  alignItems: 'center',
  borderRadius: '8px',
  ...appBorders.backrsDropShadowBorders.black,
  '@media (max-width: 900px)': {
    width: 'calc(100vw - 170px)',
  },
};

const boxStyle: SxProps<Theme> = {
  display: 'grid',
  width: '100%',
  gridTemplateColumns: '1fr auto',
  alignItems: 'flex-end',
  backgroundColor: '#ffffff',
  borderRadius: '8px',
};

const messageInputTextarea: TextareaAutosizeProps['style'] = {
  width: '100%',
  resize: 'none',
  padding: '20px 10px',
  marginLeft: '10px',
  border: 'none',
  outline: 'none',
  fontFamily: 'inherit',
  fontSize: '12pt',
  overflowY: 'auto',
  lineHeight: '1.25',
  display: 'flex',
  alignItems: 'center',
};

const inputAdornmentStyle: SxProps<Theme> = {
  height: 'auto',
  mr: 0.5,
  mb: 1.6,
  ml: 2,
};

const sendMessageIcon: React.CSSProperties = {
  width: '35px',
  height: '35px',
} as const;
